 
import React from 'react';
import { useTranslation } from 'react-i18next';
import Layout from 'components/Layout';
import LegalText from 'components/LegalText';

const CGVPage = () => {
    const { t } = useTranslation();

    return (
        <Layout pageTitle={t('page.cgv.meta-title')}>
            <h1>{t('page.cgv.title')}</h1>
            <LegalText html={t('page.cgv.text')} />
        </Layout>
    );
};

export default CGVPage;
